<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" :submit="submit" :canSubmit="false"
    :status="status" parentStoreName="Notifications_request_cms" :canUpdateDelete="false" :breadcrumbs="[
      {
        text: 'Marketing y comunicación',
        disabled: false,
        href: '/admin/notifications_request_cms'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: 'Detalle',
        disabled: true,
        href: '#'
      }
    ]">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="title" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Title</div>
                <v-text-field solo hide-details="auto" class="input-base" :error-messages="errors" readonly
                  v-model="data.title" label="Title"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <div class="label-base pb-1">Descripción</div>
              <ValidationProvider ref="description" rules="required" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.description" solo placeholder="Descripción"
                  hide-details="auto" class="text-tarea-base" rows="8" readonly />
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="py-0 px-2" cols="8">
          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="message" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Message</div>
                <v-text-field solo hide-details="auto" class="input-base" :error-messages="errors" readonly
                  v-model="data.message" label="Message"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="type_notification" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Tipo de notificacíon</div>
                <v-text-field solo hide-details="auto" class="input-base" :error-messages="errors" readonly
                  v-model="data.type_notification" label="Tipo de notificacíon"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm },
  computed: {
    ...mapState({
      status: (state) => state.Notifications_request_cms.status,
    }),
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      async handler(newId, oldId) {
        if (newId && newId !== oldId) {
          Object.assign(this.$data, this.$options.data.call(this))
          this.loadCreatedGlobal()
        }
      },
    },
  },
  data() {
    return {
      storeName: "Notifications_request_cms",
      title: "Notificación CMS",
      data: {
        title: "",
        description: "",
        is_read: false,
        is_new: true,
        message: "",
        type_notification: "",
        request_extraction_id: "",
        user_id: "",
      },
    };
  },
};
</script>
